// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZvTM","content":"styles_content__1i8hv","tableWrap":"styles_tableWrap__g_qh4"};